<template>
  <div class="search-content">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'ExameCenterLayout',
    data () {
      return {
        tabs: {
          items: [
            {
              key: '1',
              title: '考级中心考级点'
            },
            // {
            //   key: '2',
            //   title: '考级申报'
            // },
            // {
            //   key: '3',
            //   title: '考官管理'
            // }
          ],
          active: () => {
            switch (this.$route.path) {
              case '/qcxj/ExameCenterList':
                return '1'
              case '/qcxj/KaojiApplyList':
                return '2'
              case '/qcxj/KaoguanList':
                return '3'
              default:
                return '1'
            }
          },
          callback: (key) => {
            switch (key) {
              case '1':
                this.$router.push('/qcxj/ExameCenterList')
                break
              case '2':
                this.$router.push('/qcxj/KaojiApplyList')
                break
              case '3':
                this.$router.push('/qcxj/KaoguanList')
                break
              default:
                this.$router.push('/workplace')
            }
          }
        },
        search: false
      }
    },
    computed: {

    },
    methods: {
    }
  }
</script>

<style lang="less" scoped>
  .search-head{
    background-color: #fff;
    margin: -25px -24px -24px;
    .search-input{
      text-align: center;
      margin-bottom: 16px;
    }
  }
  .search-content{
    margin-top: 0px;
  }
</style>
